import SocialButtonGoogleContainer from './SocialButtonGoogle.container';
import SocialButtonGoogle from './SocialButtonGoogle';
export default SocialButtonGoogleContainer(SocialButtonGoogle);
